import axios from 'axios';
import { AuditLog, AuditLogQuery, AuditLogResponse, AuditLogStatistics } from '../types/auditLog';
import { API_BASE_URL } from '../utils/config';

const API_URL = API_BASE_URL;

class AuditLogService {
  private getAuthToken(): string | null {
    return localStorage.getItem('token');
  }

  private getAuthHeaders() {
    const token = this.getAuthToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
  }

  async getAuditLogs(query: AuditLogQuery = {}): Promise<AuditLogResponse> {
    const response = await axios.get(`${API_URL}/api/AuditLog`, {
      params: query,
      headers: this.getAuthHeaders()
    });
    return response.data;
  }

  async getEntityAuditLogs(entityType: string, entityId: string): Promise<AuditLog[]> {
    const response = await axios.get(
      `${API_URL}/api/AuditLog/entity/${entityType}/${entityId}`,
      { headers: this.getAuthHeaders() }
    );
    return response.data;
  }

  async getEntityTypes(): Promise<string[]> {
    const response = await axios.get(`${API_URL}/api/AuditLog/entity-types`, {
      headers: this.getAuthHeaders()
    });
    return response.data;
  }

  async getStatistics(startDate?: string, endDate?: string): Promise<AuditLogStatistics> {
    const params: any = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    const response = await axios.get(`${API_URL}/api/AuditLog/statistics`, {
      params,
      headers: this.getAuthHeaders()
    });
    return response.data;
  }
}

export default new AuditLogService();
